import click from '@mailobj-browser/front/js/events/types/click.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import * as generics from '#utilities/js/styles.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: async (
    option
  ) => {
    const value = option.getAttribute('value')
    
    if (value && ((value === 'cc') || (value === 'bcc'))) {
      const div = one('div[data-name="msg_' + value + '"]')
      const button = one('button[name="' + value + '"]')
      
      if (div) {
        if (div.classList.contains(generics.modifiers.display.none)) {
          div.classList.remove(generics.modifiers.display.none)
          if (button) {
            button.classList.add(generics.modifiers.display.none)
          }
        } else {
          div.classList.add(generics.modifiers.display.none)
          if (button) {
            button.classList.remove(generics.modifiers.display.none)
          }
        }
        option.classList.toggle(generics.modifiers.dropdown_item.selected)
      }
    } else if (value) {
      const field = one('span[data-name="' + value + '"]')
      if (field) {
        if (field.classList.contains(generics.modifiers.display.none)) {
          field.classList.remove(generics.modifiers.display.none)
        } else {
          field.classList.add(generics.modifiers.display.none)
        }
        option.classList.toggle(generics.modifiers.dropdown_item.selected)
      }
    }
  }
})

export default options => {
  onClick.listen(options)
}
